import * as THREE from "three";
import { ShaderManager } from "../datamanagers/shadermanager";
import type { GameContext, GameMiddleware } from "./types";

/**
 * Registers all ROSE Online shaders and waits for them to finish loading
 * before yielding to the next middleware.
 *
 * This replaces the inline ShaderManager.register() + ShaderManager.init()
 * pattern that was previously duplicated in core.ts and rose-editor.ts.
 */
export class ShaderMiddleware implements GameMiddleware {
    async init(_ctx: GameContext): Promise<void> {
        ShaderManager.register("skydome", "skydome.vert", "skydome.frag", {
            depthWrite: true,
            depthTest: false,
        });
        ShaderManager.register("terrain", "terrain.vert", "terrain.frag", {
            transparent: false,
            blending: THREE.NormalBlending,
            blendSrc: THREE.SrcAlphaFactor,
            blendDst: THREE.OneMinusSrcAlphaFactor,
            blendSrcAlpha: THREE.OneFactor,
            blendDstAlpha: THREE.OneMinusSrcAlphaFactor,
        });
        ShaderManager.register(
            "terrain_lmonly",
            "terrain.vert",
            "terrain_lmonly.frag",
            {},
        );
        ShaderManager.register("staticobj", "staticobj.vert", "staticobj.frag");
        ShaderManager.register(
            "staticobj_lmonly",
            "staticobj.vert",
            "staticobj_lmonly.frag",
        );
        ShaderManager.register("water", "water.vert", "water.frag", {
            depthWrite: false,
            transparent: true,
            blending: THREE.NormalBlending,
            blendSrc: THREE.SrcAlphaFactor,
            blendDst: THREE.OneMinusSrcAlphaFactor,
            blendSrcAlpha: THREE.OneFactor,
            blendDstAlpha: THREE.OneMinusSrcAlphaFactor,
        });
        ShaderManager.register("particle", "particle.vert", "particle.frag", {
            side: THREE.DoubleSide,
            depthWrite: false,
            transparent: true,
        });
        ShaderManager.register("partmesh", "partmesh.vert", "partmesh.frag", {});

        await new Promise<void>((resolve) => ShaderManager.init(resolve));
    }
}
